import { DeviceType } from '@frontend/device/types';
import { useEffect } from 'react';

import { useAppSelector } from '../redux/store';
import { startKeepAlive, stopKeepAlive } from './keep-alive';

/**
 * Starts native keep-alive pings once the terminal device is provisioned.
 * Stops when the component unmounts or the terminal device is cleared.
 */
export function useKeepAlive(): void {
    const device = useAppSelector((state) => state.navigation.device);

    useEffect(() => {
        const terminalDeviceId = device?.type === DeviceType.TERMINAL ? device.id : null;

        if (!terminalDeviceId) {
            return;
        }

        startKeepAlive(terminalDeviceId);

        return () => {
            stopKeepAlive();
        };
    }, [device?.id, device?.type]);
}
